/**
 * @generated SignedSource<<eedd1edf2941eb793ff0333a3fe6dce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCardForm_buyer$data = {
  readonly isTrade: boolean | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly maskedCardNumber?: string | null;
        readonly token?: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutEoriVatForm_buyer">;
  readonly " $fragmentType": "CheckoutCreditCardForm_buyer";
};
export type CheckoutCreditCardForm_buyer$key = {
  readonly " $data"?: CheckoutCreditCardForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCardForm_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutEoriVatForm_buyer"
    },
    {
      "alias": "isTrade",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maskedCardNumber",
                      "storageKey": null
                    }
                  ],
                  "type": "CreditCard",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "264d763f653e7f10c778f9e741273ab1";

export default node;
